import { isFunction } from '../../lodash';
import { Blockquote } from './Blockquote';
import { Bold } from './Bold';
import { Breaks } from './Breaks';
import { Code } from './Code';
import { CodeBlock } from './CodeBlock';
import { Deflist } from './Deflist';
import { Heading } from './Heading';
import { HorizontalRule } from './HorizontalRule';
import { Html } from './Html';
import { Image } from './Image';
import { Italic } from './Italic';
import { Link } from './Link';
import { Lists } from './Lists';
import { Mark } from './Mark';
import { Strike } from './Strike';
import { Subscript } from './Subscript';
import { Superscript } from './Superscript';
import { Table } from './Table';
import { Underline } from './Underline';
export * from './Bold';
export * from './Code';
export * from './Link';
export * from './Italic';
export * from './Strike';
export * from './Underline';
export * from './Mark';
export * from './Subscript';
export * from './Superscript';
export * from './Html';
export * from './Breaks';
export * from './Blockquote';
export * from './CodeBlock';
export * from './Deflist';
export * from './Lists';
export * from './Image';
export * from './Table';
export * from './Heading';
export * from './HorizontalRule';
export const MarkdownMarksPreset = (builder, opts) => {
    var _a, _b, _c, _d, _e;
    builder
        .use(Bold, (_a = opts.bold) !== null && _a !== void 0 ? _a : {})
        .use(Code, (_b = opts.code) !== null && _b !== void 0 ? _b : {})
        .use(Italic, (_c = opts.italic) !== null && _c !== void 0 ? _c : {})
        .use(Strike, (_d = opts.strike) !== null && _d !== void 0 ? _d : {})
        .use(Underline, (_e = opts.underline) !== null && _e !== void 0 ? _e : {})
        .use(Link)
        .use(Mark)
        .use(Subscript)
        .use(Superscript);
};
export const MarkdownBlocksPreset = (builder, opts) => {
    var _a, _b, _c, _d, _e, _f;
    builder
        .use(Html)
        .use(Table)
        .use(HorizontalRule)
        .use(Lists, (_a = opts.lists) !== null && _a !== void 0 ? _a : {})
        .use(Breaks, (_b = opts.breaks) !== null && _b !== void 0 ? _b : {})
        .use(Deflist, (_c = opts.deflist) !== null && _c !== void 0 ? _c : {})
        .use(CodeBlock, (_d = opts.codeBlock) !== null && _d !== void 0 ? _d : {})
        .use(Blockquote, (_e = opts.blockquote) !== null && _e !== void 0 ? _e : {});
    if (opts.image !== false) {
        builder.use(isFunction(opts.image) ? opts.image : Image);
    }
    if (opts.heading !== false) {
        if (isFunction(opts.heading))
            builder.use(opts.heading);
        else
            builder.use(Heading, (_f = opts.heading) !== null && _f !== void 0 ? _f : {});
    }
};
